import Vue from 'vue';
import paginationMutations from '@motionelements/core/src/store/mutations-mixins/paginationMutations.js';
import * as templatesApi from '@/api/artist/templates-edit';

const state = {
  inputItems: [
    'Creator',
    'Publisher',
    'Place',
  ],
  textareaItems: [
    'Keywords',
    'Description',
  ],
  selectItems: [
    'MediaType',
    'Country',
    'PriceTemplate',
  ],
  booleanItems: [
    'IsLoopable',
    'AllowMusicalWorks',
    'CanPublish',
  ],
  //
  metadataTemplates: [],
  //
  template: null,
  items: [],
  //
  itemsToDelete: [],
  //
  pagination: {
    page: 1,
    perPage: 5,
    totalCount: 0,
  },
  //
  defaultTemplate: null,
};

const getters = {
  options({ inputItems, textareaItems, selectItems }) {
    return [...inputItems, ...textareaItems, ...selectItems];
  },
  // eslint-disable-next-line
  allOptions({ inputItems, textareaItems, selectItems, booleanItems }) {
    return [...inputItems, ...textareaItems, ...selectItems, ...booleanItems];
  },
  templateId({ template }) {
    return _.get(template, 'id');
  },
  queryParams({ pagination: { page, perPage } }) {
    return { page, perPage };
  },
};

const actions = {
  getMetadataTemplate({ commit }, id) {
    return templatesApi.getTemplate(id, { type: 'metadata' })
      .then((template) => {
        commit('setTemplate', template);
        commit('setDefaultTemplate', _.cloneDeep(template));
      });
  },
  updateMetadataTemplate(store, { id, data }) {
    return templatesApi.updateTemplate({ templateId: id, data });
  },
  listMetadataTemplates({ commit, getters }, params) {
    params = { ...params, ...getters.queryParams };
    return templatesApi.listTemplates(params)
      .then(({ data }) => {
        commit('setMetadataTemplates', data.data);
        commit('setTotalCount', data.totalCount);
        commit('setPage', data.page);
        commit('setPerPage', data.perPage);
      })
      .catch(err => {
        console.error(err);
      });
  },
  createMetadataTemplate({ commit }, name) {
    return templatesApi.createTemplate({ type: 'metadata', name })
      .then(({ data: { data: template } }) => {
        commit('setTemplate', template);
        commit('setDefaultTemplate', _.cloneDeep(template));
      });
  },
  deleteMetadataTemplate(store, id) {
    return templatesApi.deleteTemplate(id);
  },
  createMetadataTemplateItem({ state }, { id, item }) {
    return templatesApi.createTemplateItem(id, item)
      .then(({ data: { data: item } }) => {
        const index = state.items.findIndex(x => x.key === item.key);
        if (index > -1) state.items.splice(index, 1, item);
        return item;
      });
  },
  updateMetadataTemplateItem(store, { id, itemId, item }) {
    return templatesApi.updateTemplateItem(id, itemId, item)
      .then((response) => {
        console.log(response);
        return response;
      });
  },
  deleteMetadataTemplateItem(store, { id, itemId }) {
    return templatesApi.deleteTemplateItem(id, itemId);
  },
};

const mutations = {
  setTemplateName({ template }, value) {
    if (template) template.name = value;
  },
  setAsDefault({ template }, boolean) {
    if (template) template.default = boolean;
  },
  setMetadataTemplates(state, metadataTemplates) {
    state.metadataTemplates = metadataTemplates;
  },
  setTemplate(state, template) {
    const items = _.get(template, 'items');
    if (items && items.length) {
      state.items = items;
    }
    state.template = template;
    // state.defaultTemplate = template;
  },
  setDefaultTemplate(state, template) {
    state.defaultTemplate = template;
  },
  setItems(state, items) {
    state.items = items;
  },
  selectOption({ items, itemsToDelete }, option) {
    const index = items.findIndex(x => x.key === option.key);
    if (index > -1) {
      const itemId = _.get(items[index], 'id');
      if (itemId) {
        const index = itemsToDelete.indexOf(itemId);
        if (index < 0) itemsToDelete.push(itemId);
      }
      items.splice(index, 1);
    } else {
      items.push(option);
    }
  },
  addItem({ items }, item) {
    const index = items.findIndex(x => x.key === item.key);
    if (index < 0) items.push(item);
  },
  updateItem({ items }, { key, value }) {
    const targetItem = items.find(x => x.key === key);
    if (targetItem) {
      targetItem.value = value;
      Vue.set(targetItem, 'updated', true);
    }
  },
  removeItem({ items }, key) {
    const index = items.findIndex(item => item.key === key);
    if (index > -1) items.splice(index, 1);
  },
  deleteItem({ itemsToDelete }, itemId) {
    const index = itemsToDelete.indexOf(itemId);
    if (index < 0) itemsToDelete.push(itemId);
  },
  resetTemplate(state) {
    console.log('RESET TEMPLATE');
    state.template = null;
    state.items = [];
  },
  resetItemsToDelete(state) {
    state.itemsToDelete = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations: { ...mutations, ...paginationMutations },
  actions,
};
